import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">{title}</h2>
        </div>
        {subtitle && <p className="text-sm text-foreground-600 mt-2 ml-4">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-accent-500 transition-colors shrink-0 cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}